module.exports = __webpack_public_path__ + "img/Dark Mode2_1@4x.1749bdaf.png";